<template>
  <div>
    <!-- Chat Requests -->
    <left-pane :incomingRequests="incomingRequests"/>
    <!-- Chat Pane -->
    <chat-pane v-if="isActiveChat" @tabChange="tabChange"/>
    <!-- Right Pane -->
    <right-pane v-if="isActiveChat" v-bind:selectedTab="selectedRightTab" chatType="online"
      @tabChange="tabChange" :showRightPane="showRightPane" @toggleRightPane="toggleRightPane" :showToggleButton='showToggleButton'/>
  </div>
</template>

<script>
import ChatPane from '@/components/Chat/ChatPane'
import LeftPane from '@/components/Consultations/LeftPane'
import RightPane from '@/components/RightPane'
import {mapGetters} from 'vuex'
export default {
  components: {
    ChatPane,
    LeftPane,
    RightPane
  },
  name: 'ChatMain',
  data () {
    return {
      showRightPane: false,
      consultRequests: [],
      othersAcceptedRequests: [],
      cancelledRequests: [],
      showToggleButton: true
    }
  },
  computed: {
    ...mapGetters({
      isActiveChatPresent: 'consultation/isActiveChatPresent',
      isActivePastChatPresent: 'pastConsultation/isPastChatPresent',
      requests: 'consultationRequest/getRequests',
      alreadyAssignedRequests: 'consultationRequest/getOthersAcceptedRequest',
      patientCancelledRequests: 'consultationRequest/getCancelledRequest',
      activeSection: 'configuration/getActiveSection',
      selectedRightTab: 'configuration/getActiveRightPaneTab'
    }),
    incomingRequests: function () {
      this.consultRequests = this.requests
      this.othersAcceptedRequests = this.alreadyAssignedRequests
      this.cancelledRequests = this.patientCancelledRequests
      return this.requests
    },
    isActiveChat: function () {
      if (this.activeSection === 'connected' && this.isActiveChatPresent === true) {
        return true
      } else if (this.activeSection === 'consults' && this.isActivePastChatPresent === true) {
        return true
      }
      return false
    }
  },
  methods: {
    tabChange: function (tab) {
      this.showRightPane = true
      this.$store.dispatch('configuration/setRightPaneTab', tab)
    },
    toggleRightPane: function (state) {
      this.showRightPane = state
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Chat/ChatMain.vue